export default __webpack_public_path__ + "static/media/lmb.8c12d3dd.svg";